import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Paths } from "../../router/Paths";
import { useUser } from "../../hooks/useUser";
import OTPInput from "../../components/common/OTPInput";

function VerifyEmailSection() {
  const { confirmEmail, resendSignupOTP } = useUser();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const email = searchParams.get("email");

  //  states
  const [otp, setOtp] = useState<string>("");
  const [otpError, setOtpError] = useState<string>("");
  const [verifying, setVerifying] = useState<boolean>(false);
  const [resending, setResending] = useState<boolean>(false);

  useEffect(() => {
    setOtpError("");
  }, [otp]);

  useEffect(() => {
    handleVerify(otp);
  }, [otp]);

  const handleResend = async () => {
    if (resending) return;
    await resendSignupOTP({ email: email || "", setLoading: setResending });
  };

  const handleVerify = async (code: string) => {
    if (verifying) return;
    if (!code) return;
    if (code.length !== 6)
      return setOtpError("Please enter the verification code");

    const success = await confirmEmail({
      otp: parseInt(code),
      setLoading: setVerifying,
    });

    console.log('success', success)
    if (success) {
      navigate(Paths.userType);
    }
  };

  return (
    <div className={ClassName.container}>
      <div className="bg-[#F8F8F8] rounded-2xl w-full max-w-[540px] py-6 px-3 lg:px-6 flex flex-col items-center mx-2">
        <img src="/emailSvg.svg" alt="" className="w-20 object-contain" />
        <span className="text-3xl lg:text-4xl font-bold mb-4">
          Verify your email address
        </span>
        <span className="text-sm lg:text-base text-[#818083]">
          Please enter the verification code sent to your email
        </span>
        <span className={ClassName.label}>{email}</span>
        <OTPInput
          classname="mt-3 mb-2"
          onChange={(value) => {
            setOtp(value);
          }}
        />
        {otpError && <span className={ClassName.error}>{otpError}</span>}
        <button
          onClick={() => handleVerify(otp)}
          className="h-12 w-full rounded-lg bg-primary text-white font-bold text-sm lg:text-base mt-4"
        >
          {verifying ? "Please wait ... " : "Verify"}
        </button>
        <div className="w-full flex flex-col items-center mt-4">
          <span
            className={`${ClassName.label} cursor-pointer mt-0 text-[#B5B5B5]`}
          >
            Did not get any email?
            <span className="text-primary" onClick={handleResend}>
              {" "}
              {resending ? "Please wait... " : "Resend"}
            </span>
          </span>
        </div>
      </div>
    </div>
  );
}

export default VerifyEmailSection;

const ClassName = {
  container: "w-full h-screen flex items-center justify-center",
  input:
    "border rounded-lg flex flex-1 px-4 py-3 bg-transparent border-[#DBDBDB]",
  error: "text-red-600 text-sm mt-2 mb-2",
  label: "text-[#818083] text-sm lg:text-base font-bold mb-1",
};
